"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SkuSellScene;
(function (SkuSellScene) {
    SkuSellScene[SkuSellScene["DIRECT"] = 0] = "DIRECT";
    SkuSellScene[SkuSellScene["PREORDER"] = 1] = "PREORDER";
    SkuSellScene[SkuSellScene["HAVE_COUPONS"] = 2] = "HAVE_COUPONS";
    SkuSellScene[SkuSellScene["NONE_COUPONS"] = 3] = "NONE_COUPONS";
    SkuSellScene[SkuSellScene["LIMITED_TIME_SALE"] = 4] = "LIMITED_TIME_SALE";
})(SkuSellScene = exports.SkuSellScene || (exports.SkuSellScene = {}));
var CourseExchangeStatus;
(function (CourseExchangeStatus) {
    CourseExchangeStatus[CourseExchangeStatus["INELIGIBLE"] = 0] = "INELIGIBLE";
    CourseExchangeStatus[CourseExchangeStatus["EXCHANGEABLE"] = 1] = "EXCHANGEABLE";
    CourseExchangeStatus[CourseExchangeStatus["EXCHANGED"] = 2] = "EXCHANGED";
    CourseExchangeStatus[CourseExchangeStatus["CUTOFF"] = 3] = "CUTOFF";
})(CourseExchangeStatus = exports.CourseExchangeStatus || (exports.CourseExchangeStatus = {}));
//# sourceMappingURL=marketingActivity.js.map


//////////////////
// WEBPACK FOOTER
// ../core/dist/src/types/marketingActivity.js
// module id = 1003
// module chunks = 0